import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { map, tap, switchMap, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  uri = environment.url;

  private _profile = new BehaviorSubject(null);

  get profile() {
    return this._profile.asObservable();
  }

  constructor(
    private http: HttpClient,
  ) {}

  loadProfile(): Promise<any> {
  return this.http.get(this.uri + '/api/v1/profile/me')
    .toPromise()
    .then((resp: any) => {
      const { item } = resp.result;
      this._profile.next(item);
    });
}


  fetchSubscriptionData() {
    return this.http
      .get(this.uri + `/api/v1/profile/subscription`)
      .pipe(
        map((resp: any) => {
          const { item } = resp.result;
          return item;
        })
      )
      .toPromise();
  }

  fetchMyProfile() {
    return this.http.get(this.uri + `/api/v1/profile/me`).pipe(
      tap((resp: any) => {
        const { item } = resp.result;
        this._profile.next(item);
      }, () => this._profile.next(null))
    );
  }

getProfile(): Observable<any> {
  return this.fetchMyProfile().pipe(
    map((resp: any) => resp?.result?.item || null), // ← extraemos solo item
    catchError(error => {
      if (error?.status === 401) {
        console.error('Error 401: No autorizado');
        // acción adicional: redirigir, limpiar sesión, etc.
      } else {
        console.error('Error inesperado:', error);
      }
      return of(null); // devuelve null si hay error
    })
  );
}

  updateProfile(data) {
    return this.http
      .put(this.uri + `/api/v1/profile/me`, data)
      .pipe(switchMap(() => this.fetchMyProfile()))
      .toPromise();
  }

  deleteAccount() {
    return this.http.delete(this.uri + `/api/v1/profile/me`).toPromise();
  }

  clearProfile() {
    this._profile.next(null);
  }
}
